import { catchError, finalize, of } from "rxjs";
import { AlertService } from "src/app/components/alert/alert.service";
import { AbstractDatasource } from "src/app/modules/shared/components/be-paginated-table/abstract.datasource";
import { IDashboardOperation, IDashboardOperationRequest, IDashboardOperationResponse } from "src/app/modules/shared/models/operation.model";
import { LoggerService } from "src/app/services/logger.service";
import { DashboardService } from "./dashboard.service";
import { CommonUtils } from "src/app/utils/CommonUtils";

export class DashboardDatasource extends AbstractDatasource<IDashboardOperation, IDashboardOperationRequest> {

    constructor(private _dashboardService: DashboardService,
        private _alertService: AlertService) {
        super();
    }

    search(body: IDashboardOperationRequest) {
        this.loadingSubject.next(true);
        this._dashboardService.getDashboardOperations(body)
            .pipe(
                catchError(error => {
                    LoggerService.logError(this.constructor.name, 'getOperations', { error });
                    this._alertService.openErrorMessage('', 'getOperations', error);
                    this.loadingSubject.next(false);
                    const errResp: IDashboardOperationResponse = null;
                    return of(errResp);
                }),
                finalize(() => {
                    this.loadingSubject.next(false);
                })
            )
            .subscribe(response => {
                LoggerService.logInfo(this.constructor.name, 'getOperations', { response });
                if (response) {
                    const results: IDashboardOperation[] = CommonUtils.manageDashboardData(CommonUtils.checkAndGet(response, 'data', null));
                    this.length = (response.total) || 0;
                    this.resultSubject.next(results);
                    this.loadingSubject.next(false);
                }
            });
    }

    disconnect() {
        this.resultSubject.next([]);
    }

}